<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-row>
          <el-col>
            <rest-form-item
              prop="name"
              :label="$t('ApplicationForm_Field_Title')"
            >
              <el-input v-model="model.name" />
            </rest-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <rest-form-item
              prop="web_title"
              :label="$t('ApplicationForm_Field_WebsiteTitle')"
            >
              <el-input v-model="model.web_title" />
            </rest-form-item>
          </el-col>

          <el-col>
            <rest-form-item
              prop="web_url"
              :label="$t('ApplicationForm_Field_WebsiteURL')"
            >
              <el-input v-model="model.web_url" />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <rest-form-item
              prop="web_domain"
              :label="$t('ApplicationForm_Field_AllowedHTTPOrigins')"
            >
              <el-input type="textarea" v-model="model.web_domain" :rows="6" />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <rest-form-item
              prop="c"
              :label="$t('ApplicationForm_Field_ClientCookies')"
            >
              <el-switch
                v-model="clientCookies"
                :inactive-value="false"
                :active-value="true"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row class="example-row" v-if="clientCookies">
          <el-col>
            <rest-form-item
              :hint="
                `${$t('ApplicationForm_Row_WebsiteSettingsPrefixDomain')} ${$t(
                  'ApplicationForm_Row_WebsiteSettingsExample'
                )}`
              "
              prop="web_push_cookie_domain"
              :label="$t('ApplicationForm_Field_CookieDomain')"
            >
              <el-input
                ref="cookie-domain"
                v-model="model.webpush_cookie_domain"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col class="el-col-" :span="null">
            <rest-form-item
              prop="web_icon_small_file"
              :label="$t('ApplicationForm_Field_SmallIcon')"
            >
              <icon-upload
                :value="model.web_icon_small"
                :file.sync="model.web_icon_small_file"
                accepts=".png"
              />
            </rest-form-item>
          </el-col>
          <el-col class="el-col-" :span="null">
            <rest-form-item
              prop="web_icon_large_file"
              :label="$t('ApplicationForm_Field_LargeIcon')"
            >
              <icon-upload
                :value="model.web_icon_large"
                :file.sync="model.web_icon_large_file"
                accepts=".png"
              />
            </rest-form-item>
          </el-col>
          <el-col>
            <rest-form-item
              prop="ga_tracking_id"
              :label="$t('ApplicationForm_Field_GaTrackingId')"
            >
              <el-input
                v-model="model.ga_tracking_id"
                maxlength="32"
                placeholder="G-XXXXXX"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import IconUpload from '@/common/components/form/IconUpload'

export default {
  name: 'AppWebForm',
  components: { IconUpload, RestFormItem },
  props: {
    model: {
      required: true,
      type: Object
    },
    files: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      clientCookies: !!this.model.webpush_cookie_domain
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    }
  },
  watch: {
    clientCookies(newValue) {
      if (!newValue) {
        this.$refs['cookie-domain'].clear()
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/AppWebForm.vue